import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=3f95924d&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=3f95924d&prod&scoped=true&lang=scss"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=3f95924d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95924d",
  null
  
)

export default component.exports